/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContentReportResponse } from '../models/ContentReportResponse';
import type { CreateContentReportDto } from '../models/CreateContentReportDto';
import type { UpdateContentReportDto } from '../models/UpdateContentReportDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ContentReportsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Report content
     * Create a new content report. Any authenticated user can report content. Duplicate reports for the same content by the same user are rejected. Auto-hides content when 5 distinct users report it.
     * @returns ContentReportResponse Content report created successfully.
     * @throws ApiError
     */
    public contentReportsControllerCreate({
        requestBody,
    }: {
        requestBody: CreateContentReportDto,
    }): CancelablePromise<ContentReportResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/content-reports',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                404: `Content to report not found.`,
                409: `You have already reported this content.`,
            },
        });
    }
    /**
     * List content reports
     * Returns a paginated list of content reports with optional filters. Each report includes the total report count for the same target, the target moderation status, and a content preview. Supports sorting by reportCount to surface most-reported content first. ADMIN only.
     * @returns any List of content reports.
     * @throws ApiError
     */
    public contentReportsControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        reportableType,
        status,
        reason,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page
         */
        limit?: number,
        /**
         * Sort by field. Use "reportCount" to sort by number of reports against the same content.
         */
        sortBy?: 'createdAt' | 'updatedAt' | 'status' | 'reportCount',
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by reportable content type
         */
        reportableType?: 'POST' | 'NEIGHBORING_REPORT' | 'NEIGHBORING_REPORT_COMMENT',
        /**
         * Filter by report status
         */
        status?: 'PENDING' | 'REVIEWED' | 'RESOLVED' | 'DISMISSED',
        /**
         * Filter by report reason
         */
        reason?: 'SPAM' | 'HARASSMENT' | 'INAPPROPRIATE_CONTENT' | 'MISINFORMATION' | 'VIOLENCE' | 'HATE_SPEECH' | 'OTHER',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/content-reports',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'reportableType': reportableType,
                'status': status,
                'reason': reason,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Get content report by ID
     * Returns a single content report with full details including content preview, report count, and moderation status of the reported content. ADMIN only.
     * @returns ContentReportResponse Content report found.
     * @throws ApiError
     */
    public contentReportsControllerFindOne({
        id,
    }: {
        /**
         * Content report unique identifier
         */
        id: string,
    }): CancelablePromise<ContentReportResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/content-reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Content report not found.`,
            },
        });
    }
    /**
     * Resolve or dismiss a content report
     * Update the status of a content report to RESOLVED or DISMISSED. Sets the resolving admin and timestamp. ADMIN only.
     * @returns ContentReportResponse Content report updated successfully.
     * @throws ApiError
     */
    public contentReportsControllerResolve({
        id,
        requestBody,
    }: {
        /**
         * Content report unique identifier
         */
        id: string,
        requestBody: UpdateContentReportDto,
    }): CancelablePromise<ContentReportResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/content-reports/{id}/resolve',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Content report not found.`,
            },
        });
    }
    /**
     * Hide reported content
     * Hides the content associated with a report by setting its moderationStatus to HIDDEN. Also resolves all PENDING reports on the same content. Idempotent: returns 200 if already hidden. ADMIN only.
     * @returns ContentReportResponse Content hidden successfully. All pending reports on this content are resolved.
     * @throws ApiError
     */
    public contentReportsControllerHide({
        id,
    }: {
        /**
         * Content report unique identifier
         */
        id: string,
    }): CancelablePromise<ContentReportResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/content-reports/{id}/hide',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Content report not found.`,
            },
        });
    }
    /**
     * Restore hidden content
     * Restores hidden content by setting its moderationStatus back to VISIBLE. Dismisses all reports on the same content that were resolved by the hide action. Idempotent. ADMIN only.
     * @returns ContentReportResponse Content restored successfully. Related reports are dismissed.
     * @throws ApiError
     */
    public contentReportsControllerRestore({
        id,
    }: {
        /**
         * Content report unique identifier
         */
        id: string,
    }): CancelablePromise<ContentReportResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/content-reports/{id}/restore',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Content report not found.`,
            },
        });
    }
}
